import Vue from 'vue';
import { Servicelayer } from '@glittr/frontend-core/src/plugins/servicelayer';
import SiHaSafetyHookApi from '../generated/api/SiHaSafetyHook';

export default (service: Servicelayer) => ({
  ...SiHaSafetyHookApi(service),

  // Add custom calls here

});
